import { createIcon } from '@chakra-ui/icons';

export const AlbumIcon = createIcon({
  displayName: 'AlbumIcon',
  viewBox: '0 0 40 41',
  d: 'M18.402 20.207L18 19.666l-.401.54-6 8.082-.593.798h26.028l-.642-.81-8-10.102L28 17.68l-.392.494-5.535 6.984-3.671-4.95zM3.5 36.667v.5h28v3.04H4c-1.92 0-3.5-1.59-3.5-3.54V8.884h3v27.783zm36-32.324v24.243c0 1.95-1.58 3.54-3.5 3.54H12c-1.92 0-3.5-1.59-3.5-3.54V4.343c0-1.95 1.58-3.54 3.5-3.54h24c1.92 0 3.5 1.59 3.5 3.54z',
});
